module.exports = __webpack_public_path__ + "static/media/one-class-label-logo.c27a8981.svg";